import React from 'react'
import { Box, Table, Paper, Image, Text, Badge, Menu, ActionIcon } from '@mantine/core'
import { IconDotsVertical, IconPencil, IconTrash } from '@tabler/icons-react'
import NoImage from '../../../assets/img/images/no-images.png'

const ActionMenu = ({ handleAction, detail }) => {
  return (
    <Menu width={200} position="bottom-end" withArrow arrowPosition="center">
      <Menu.Target>
        <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
          <IconDotsVertical stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconPencil stroke={1.5} size={14} />}
          onClick={() => handleAction('edit')}
          fw='600'
          fz={11}
        >
          Edit
        </Menu.Item>
        <Menu.Item
          color='red'
          leftSection={<IconTrash stroke={1.5} size={14} />}
          onClick={() => handleAction('delete')}
          fw='600'
          fz={11}
        >
          Delete
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

const TableBanners = ({ label, data, actionMethod }) => {
  const mappingTableHead = (data) => data.map((val, index) => {
    return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
  })

  const mappingDataTable = (data) => data.map((val, index) => {
    return (
      <Table.Tr key={index}>
        <Table.Td>
          <Box h={40}>
            <Text fz={13} lineClamp={2} c={'blue'}>{val.name}</Text>
          </Box>
        </Table.Td>
        <Table.Td>
          <Paper shadow="sm" w={62} withBorder radius='md'  style={{ cursor: 'pointer' }}>
            <Image w={60} h={60} radius='md' src={val.image !== null ? val.image : NoImage} onClick={() => actionMethod(val, 'showImage')} />
          </Paper>
        </Table.Td>
        <Table.Td>
          <Box h={40}>
            <Text fz={13} lineClamp={2}>Open {val.actionType === 'category_brand' ? 'category brand' : val.actionType} page</Text>
          </Box>
        </Table.Td>
        <Table.Td><Badge variant="light" color="red" tt='uppercase'>{val.position}</Badge></Table.Td>
        <Table.Td>
          <Box h={40}>
            <Text fz={13} lineClamp={2}>{val.priority}</Text>
          </Box>
        </Table.Td>
        <Table.Td><Badge variant="light" color={val.status === 'active' ? 'green' : 'gray'}>{val.status}</Badge></Table.Td>
        <Table.Td><ActionMenu handleAction={(type) => actionMethod(val, type)} detail={val} /></Table.Td>
      </Table.Tr>
    )
  })

  return (
    <Table.ScrollContainer minWidth={1366} type='native'>
      <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
        <Table.Thead style={{ backgroundColor: '#eeefef' }}>
          <Table.Tr>
            {mappingTableHead(label)}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody style={{ verticalAlign: 'top' }}>
          {mappingDataTable(data)}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  )
}

export default TableBanners